import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule, NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  FwAppIconModule,
  FwAvatarModule,
  FwButtonComponent,
  FwButtonModule,
  FwCheckboxModule,
  FwChipModule,
  FwDateInputModule,
  FwDialogsModule,
  FwIconButtonModule,
  FwIconModule,
  FwLayoutContextComponent,
  FwLayoutsModule,
  FwMenuModule,
  FwNavbarModule,
  FwPopoverComponent,
  FwPopoverModule,
  FwProgressModule,
  FwRadioModule,
  FwSelectMenuModule,
  FwTextInputModule,
  FwTooltipModule,
} from '@flywheel-io/vision';

import { AppAvatarComponent } from './components/app-avatar/app-avatar.component';
import { AppButtonGroupComponent } from './components/app-button-group/app-button-group.component';
import { AppSelectComponent } from './components/app-select/app-select.component';
import { AppSideBarSearchExpandableBlockComponent } from './components/app-side-bar-search/app-side-bar-search-expandable-block/app-side-bar-search-expandable-block.component';
import { AppSideBarSearchComponent } from './components/app-side-bar-search/app-side-bar-search.component';
import { AppTopBarComponent } from './components/app-top-bar/app-top-bar.component';
import { FwActionMenuComponent } from './components/fw-action-menu/fw-action-menu.component';
import { FwApiKeyTable } from './components/fw-api-key-table/fw-api-key-table.component';
import { GenerateApiKeyDialog } from './components/fw-api-key-table/generate-api-key-dialog/generate-api-key-dialog.component';
import { FwAutocompleteComponent } from './components/fw-autocomplete/fw-autocomplete.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FwChipInputComponent } from './components/fw-chip-input/fw-chip-input.component';
import { FwChipSelectorComponent } from './components/fw-chip-selector/fw-chip-selector.component';
import { FwContainerPermissionsComponent } from './components/fw-container-permissions/fw-container-permissions.component';
import { FwDeleteReasonComponent } from './components/fw-delete-reason/fw-delete-reason.component';
import { FwEllipsisComponent } from './components/fw-ellipsis/fw-ellipsis.component';
import { FwLoadingComponent } from './components/fw-loading/fw-loading.component';
import { FwMfaCodeComponent } from './components/fw-mfa-code/fw-mfa-code.component';
import { FwOverflowMenuComponent } from './components/fw-overflow-menu/fw-overflow-menu.component';
import { FwRulesCreatorComponent } from './components/fw-rules-creator/fw-rules-creator.component';
import { FwSaveBarComponent } from './components/fw-save-bar/fw-save-bar.component';
import { FwSortIconComponent } from './components/fw-sort-icon/fw-sort-icon.component';
import { FwTagsComponent } from './components/fw-tags/fw-tags.component';
import { LayoutComponent } from './components/layout/layout.component';
import { ProjectPickerComponent } from './components/project-picker/project-picker.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FwButtonLikeDirective } from './directives/fw-button-like/fw-button-like.directive';
import { FwDeferForOf } from './directives/fw-defer-for-of/fw-defer-for-of.directive';
import { FwLoadTrigger } from './directives/fw-load-trigger/fw-load-trigger.directive';
import { FwOverlayPanelClassDirective } from './directives/fw-overlay-panel-class/fw-overlay-panel-class.directive';
import { VarDirective } from './directives/ng-var.directive';
import { AppUserDirective } from './directives/user-avatar.directive';
import { MaterialModule } from '../material.module';
import { PipesModule } from './pipes.module';
import { LoginComponent } from '../login/login.component';
import { TypeaheadComponent } from './components/typeahead/typeahead.component';
import { FwResizedDirective } from './directives/resize.directive';
import { FwTimeFieldComponent } from './components/fw-time-field/fw-time-field.component';

@NgModule({
  imports: [
    CdkMenuModule,
    CommonModule,
    DragDropModule,
    FormsModule,
    FwAppIconModule,
    FwAvatarModule,
    FwButtonModule,
    FwButtonModule,
    FwCheckboxModule,
    FwChipModule,
    FwDateInputModule,
    FwIconButtonModule,
    FwIconModule,
    FwLayoutsModule,
    FwMenuModule,
    FwNavbarModule,
    FwPopoverModule,
    FwProgressModule,
    FwRadioModule,
    FwSelectMenuModule,
    FwTextInputModule,
    MatCheckboxModule,
    MaterialModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatSortModule,
    MatTooltipModule,
    NgClass,
    NgForOf,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    PipesModule,
    ReactiveFormsModule,
    RouterModule,
    FwTooltipModule,
    FwResizedDirective,
    FwTimeFieldComponent,
  ],
  exports: [
    AppAvatarComponent,
    AppButtonGroupComponent,
    AppSelectComponent,
    AppTopBarComponent,
    AppUserDirective,
    FwActionMenuComponent,
    FwApiKeyTable,
    FwAutocompleteComponent,
    BreadcrumbComponent,
    FwButtonComponent,
    FwButtonLikeDirective,
    FwChipInputComponent,
    FwChipSelectorComponent,
    FwContainerPermissionsComponent,
    FwDeferForOf,
    FwDeleteReasonComponent,
    FwDialogsModule,
    FwEllipsisComponent,
    FwIconButtonModule,
    FwLayoutContextComponent,
    FwLoadTrigger,
    FwLoadingComponent,
    FwMenuModule,
    FwMfaCodeComponent,
    FwOverflowMenuComponent,
    FwOverlayPanelClassDirective,
    FwPopoverComponent,
    FwRulesCreatorComponent,
    FwSaveBarComponent,
    FwSortIconComponent,
    FwTagsComponent,
    LoginComponent,
    TypeaheadComponent,
    GenerateApiKeyDialog,
    NgClass,
    NgForOf,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    ProjectPickerComponent,
    SidebarComponent,
    VarDirective,
    LayoutComponent,
  ],
  declarations: [
    AppAvatarComponent,
    AppSelectComponent,
    AppButtonGroupComponent,
    AppSideBarSearchComponent,
    AppSideBarSearchExpandableBlockComponent,
    AppTopBarComponent,
    AppUserDirective,
    FwActionMenuComponent,
    FwApiKeyTable,
    FwAutocompleteComponent,
    BreadcrumbComponent,
    FwButtonLikeDirective,
    FwChipInputComponent,
    FwChipSelectorComponent,
    FwContainerPermissionsComponent,
    FwDeferForOf,
    FwDeleteReasonComponent,
    FwEllipsisComponent,
    FwLoadTrigger,
    FwLoadingComponent,
    FwMfaCodeComponent,
    FwOverflowMenuComponent,
    FwOverlayPanelClassDirective,
    FwRulesCreatorComponent,
    FwSaveBarComponent,
    FwSortIconComponent,
    FwTagsComponent,
    LoginComponent,
    TypeaheadComponent,
    GenerateApiKeyDialog,
    ProjectPickerComponent,
    SidebarComponent,
    VarDirective,
    LayoutComponent,
  ],
})
export class SharedModule {
}
